import { HttpRequest } from '@angular/common/http';

/**
 * Serialize an Angular HttpRequest into a raw HTTP/1.1 request string
 * suitable for sending over a Ziti dial connection.
 *
 * Auth headers (zt-session / Authorization) are expected to already be
 * present on the request (set by the interceptor's addAuthToken()).
 */
export function serializeHttpRequest(
    request: HttpRequest<any>
): string {
    const url = new URL(request.urlWithParams);
    const path = url.pathname + url.search;
    const host = url.host;

    const lines: string[] = [];

    // Request line
    lines.push(`${request.method} ${path} HTTP/1.1`);

    // Required headers
    lines.push(`Host: ${host}`);
    lines.push('Connection: keep-alive');

    // Carry over all existing request headers (includes auth headers set by addAuthToken)
    const skipHeaders = new Set(['host', 'connection', 'content-type', 'content-length']);
    request.headers.keys().forEach((key) => {
        if (!skipHeaders.has(key.toLowerCase())) {
            const value = request.headers.get(key);
            if (value !== null) {
                lines.push(`${key}: ${value}`);
            }
        }
    });

    // Body
    const body = request.body ? JSON.stringify(request.body) : '';
    if (body) {
        lines.push(`Content-Type: application/json`);
        lines.push(`Content-Length: ${new TextEncoder().encode(body).length}`);
        lines.push('');
        lines.push(body);
    } else {
        lines.push('');
        lines.push('');
    }

    return lines.join('\r\n');
}
